import axios from 'axios';

export default async () => {
  let access = "1913fb72cb898b1febbc2c7c2ddfd39a"
  let response = await axios.get(`https://api.ipstack.com/check?access_key=${access}&fields=ip,country_code`)
  return response.data
}